import { API_POST_CONTACT_US_PUBLIC } from "api/auth";
import axios from "axios";
import { CONSTANTS } from "config/constant";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import * as Yup from "yup";

const ContactUsPublic = () => {
  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      phone_no: "",
      company_name: "",
      //   inquiry: "",
      message: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required"),
      email: Yup.string().email("Invalid email").required("Email is required"),
      phone_no: Yup.string().required("Phone number is required"),
      // .matches(/^[0-9]{7,15}$/, "Invalid phone number")
      // .required("Phone number is required"),
      company_name: Yup.string().required("Company name is required"),
      //   inquiry: Yup.string().required("Please select an option"),
      message: Yup.string().required("Message is required"),
    }),
    onSubmit: async (values, { resetForm, setSubmitting, }) => {
      try {
        const response = await axios.post(
          `${CONSTANTS?.IMG_DIRECTORY}api/public/user-query`,
          values,
          {
            headers: { "Content-Type": "application/json" },
          }
        );

        if (response.status === 200 || response.status === 201) {
          toast.success("Your message has been sent successfully!");
          resetForm();
        } else {
          toast.error("Something went wrong. Please try again.");
        }
      } catch (error) {
        toast.error(
          error.response?.data?.message ||
            "Failed to submit. Please check your connection."
        );
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <div className="mx-auto mt-14 max-w-2xl rounded-lg bg-white p-6 shadow-md">
      <form onSubmit={formik.handleSubmit} className="space-y-4">
        <h1 className="text-center text-2xl font-semibold">Contact Us</h1>
        {/* Name & Email */}
        <div className="grid grid-cols-2 gap-4">
          <div>
            <input
              type="text"
              name="name"
              placeholder="Name"
              className="w-full rounded-lg border p-3"
              {...formik.getFieldProps("name")}
            />
            {formik.touched.name && formik.errors.name && (
              <p className="text-sm text-red-500">{formik.errors.name}</p>
            )}
          </div>
          <div>
            <input
              type="email"
              name="email"
              placeholder="Email"
              className="w-full rounded-lg border p-3"
              {...formik.getFieldProps("email")}
            />
            {formik.touched.email && formik.errors.email && (
              <p className="text-sm text-red-500">{formik.errors.email}</p>
            )}
          </div>
        </div>

        {/* Phone */}
        <div className="grid grid-cols-1 gap-2">
          {/* <div className="flex items-center bg-gray-100 p-3 rounded-lg">+66</div> */}
          <div className="col-span-2">
            <input
              type="text"
              name="phone_no"
              placeholder="Phone Number"
              className="w-full rounded-lg border p-3"
              {...formik.getFieldProps("phone_no")}
            />
            {formik.touched.phone_no && formik.errors.phone_no && (
              <p className="text-sm text-red-500">{formik.errors.phone_no}</p>
            )}
          </div>
        </div>

        {/* Company & Inquiry */}
        <div className="grid grid-cols-1 gap-4">
          <div>
            <input
              type="text"
              name="company_name"
              placeholder="Company Name"
              className="w-full rounded-lg border p-3"
              {...formik.getFieldProps("company_name")}
            />
            {formik.touched.company_name && formik.errors.company_name && (
              <p className="text-sm text-red-500">
                {formik.errors.company_name}
              </p>
            )}
          </div>
          {/* <div>
            <select
              name="inquiry"
              className="w-full p-3 border rounded-lg"
              {...formik.getFieldProps("inquiry")}
            >
              <option value="" disabled>What are you Seeking?</option>
              <option value="service">Service Inquiry</option>
              <option value="support">Technical Support</option>
              <option value="partnership">Partnership</option>
            </select>
            {formik.touched.inquiry && formik.errors.inquiry && (
              <p className="text-red-500 text-sm">{formik.errors.inquiry}</p>
            )}
          </div> */}
        </div>

        {/* Message */}
        <div>
          <textarea
            name="message"
            placeholder="Message"
            rows="4"
            className="w-full rounded-lg border p-3"
            {...formik.getFieldProps("message")}
          ></textarea>
          {formik.touched.message && formik.errors.message && (
            <p className="text-sm text-red-500">{formik.errors.message}</p>
          )}
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          className="w-full rounded-lg bg-blue-500 p-3 text-white transition hover:bg-blue-600"
        >
          SUBMIT
        </button>
      </form>
    </div>
  );
};

export default ContactUsPublic;
